import React from "react";
import axios from "axios";
import { cartURL, applyCouponURL, INBOUND, OUTBOUND, TRANSACTIONAL_API } from "../utils/constants";
import {
    updateCartStart,
    updateCartSuccess,
    updateCartError,
    fetchCartStart,
    fetchCartSuccess,
    fetchCartError,
    applyCouponStart,
    applyCouponSuccess,
    applyCouponError,
} from "../actions/appActions";
import { message } from "antd";
import { contactSupport } from "../utils/links";
import { inboundTransform, outboundTransform, transactionalTransform } from "./fetchAllPlansAPI";

const updateCart = async (params, dispatch) => {
    dispatch(updateCartStart());
    try {
        const result = await axios.post(cartURL, params);
        dispatch(updateCartSuccess(cartShapeTransform(result.data)));
    } catch (error) {
        const errMsg = error && error.response && error.response.data && error.response.data.messageId
                        ? error.response.data.messageId
                        : error.message;

        if (errMsg.includes("update_cart.error.invalid_token")) {
            message.error(
                <span>
                {"Sorry, the signup link is invalid, please contact Support at: "}
                    {contactSupport}
            </span>
            );
        } else {
            message.error(
                <span>
                {"Sorry, there was an error completing your request, please try again later or contact Support at: "}
                    {contactSupport}
            </span>
            );
        }

        dispatch(updateCartError(error));
        console.log(error);

        throw error;
    }
};

const cartShapeTransform = rawData => {
    return {
        ...rawData,
        items: rawData.items.map(item => ({
            ...item,
            plan:
                (item.productHandle === INBOUND ? inboundTransform(item.plan)
                    : (item.productHandle === OUTBOUND ? outboundTransform(item.plan) 
                    : (item.productHandle === TRANSACTIONAL_API ? transactionalTransform(item.plan) : []))),
        })),
    };
};

const fetchCart = async dispatch => {
    dispatch(fetchCartStart());
    try {
        const result = await axios.get(cartURL);
        dispatch(fetchCartSuccess(cartShapeTransform(result.data)));
    } catch (error) {
        let errorMsg;
        if (error.response) {
            //The request was made and server responded
            errorMsg = error.response.data;
        } else {
            //Error happened during setting up the request
            errorMsg = error.message;
        }
        dispatch(fetchCartError(errorMsg));
        console.log(error);
    }
};

const applyCoupon = async (cartItemID, coupon, dispatch) => {
    dispatch(applyCouponStart());
    try {
        const result = await axios.post(applyCouponURL, {
            cartItemId: cartItemID,
            couponCode: coupon,
        });
        dispatch(applyCouponSuccess(cartShapeTransform(result.data)));
        return result;
    } catch (error) {
        if (error.response) {
            //request with response
            dispatch(applyCouponError(error));
        } else {
            message.error(
                <span>
                    {
                        "Sorry, there was an error completing your request, please try again later or contact Support at: "
                    }
                    {contactSupport}
                </span>
            );
        }

        console.log(error);

        return null;
    }
};

export { updateCart, fetchCart, applyCoupon };
